import {Component, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE, EMPTY_USER, EVOL_DEMO_LAST_YEAR, PRICE_EVOL_LEGENT} from '@models/empty';
import {User} from '@models/user';
import {PdfConfig} from '@models/pdf';
import {environment} from '~/environments/environment';
import {CityService} from '@services/city.service';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {AdService} from '@services/ad.service';
import {UserService} from '@services/user.service';
import {AuthenticationService} from '@services/authentification.service';
import {MatDialog} from '@angular/material/dialog';
import {AlertService} from '@services/alert.service';
import {TrackingService} from '@services/tracking.service';
import * as htmlToImage from 'html-to-image';
import {jsPDF} from 'jspdf';
import * as $ from 'jquery';
import * as _ from 'underscore';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';

@Component({
    selector: 'app-izimmo',
    templateUrl: './izimmo.component.html',
    styleUrls: ['./izimmo.component.scss']
})
export class IzimmoComponent implements OnInit {

    favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    user: User = Object.assign({}, EMPTY_USER);
    pdfConfig: PdfConfig;

    fontSize = 24;

    params;
    result: any[] = [];
    displayedColumns: string[] = [];
    amort_moy = 0;
    apiUrl = environment.apiUrl;
    hideUnit = false;
    imgDone: string[] = [];
    imgAnnonce = '';
    imgSecteur = '';
    imgSecteurBis = '';
    imgFinance = '';
    imgPatrimoniale = '';
    ready = false;
    loading = false;
    enrichment = 0;
    enrichment_10 = 0;

    data_CF_cum = [];

    advice_price = 0;
    rand = Math.floor(Date.now() / 1000);

    stripe = Stripe(environment.stripeKey);

    /**
     * Chart repartition
     */
    chargeEchartsIntance = null;
    chargeOptions = {
        tooltip: {
            trigger: 'item',
            formatter: '{c}€ ({d}%)'
        },
        legend: {
            orient: 'vertical',
            right: '0px',
            top: '30px',
            align: 'right',
            textStyle: {
                fontSize: 14,
            },
        },
        calculable: true,
    };
    chargeData = {
        series: []
    };

    /**
     * Chart price evol
     */
    priceEvolEchartsIntance = null;
    priceEvolOptions = {
        legend: {
            orient: 'vertical',
            right: '20px',
            bottom: '40px',
            align: 'right',
            selected: {},
        },
        grid: {
            left: '1%',
            right: '3%',
            top: '10',
            bottom: '15',
            containLabel: true,
        },
        xAxis: {
            data: [],
            axisLabel: {
                fontSize: 12
            }
        },

        yAxis: {
            type: 'value',
            label: {
                formatter: '{b} <br/>{a} : {c} €/m²',
            },
            min: 10000,
            axisLabel: {
                formatter: '{value} €/m²',
                fontSize: 12
            }
        },
        color: ['#2980B9', '#8E44AD ', '#C0392B', '#E67E22'],
        series: []
    };
    priceEvolData = {
        series: [],
    };

    /**
     * Chart prix
     */
    priceEchartsIntance = null;
    priceOptions = {
        label: {
            show: true,
            position: 'insideRight',
            color: 'white',
            fontSize: 16,
            formatter: d => {
                return d.data > 0 ? parseFloat(d.data).toLocaleString('fr-FR', {
                    style: 'currency',
                    currency: 'EUR'
                }) + '/m²' : '';
            }
        },
        grid: {
            left: '1%',
            right: '3%',
            top: '0',
            bottom: '15',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            max: 1,
        },
        yAxis: {
            type: 'category',
            data: [],
            axisLabel: {
                fontSize: 12
            }
        },

        color: ['#004854', '#BA7D3E'],
        series: []
    };
    priceData = {
        series: [],
    };

    /**
     * Chart Loyer
     */
    rentEchartsIntance = null;
    rentOptions = {
        label: {
            show: true,
            position: 'insideRight',
            color: 'white',
            fontSize: 16,
            formatter: d => {
                return d.data > 0 ? parseFloat(d.data).toLocaleString('fr-FR', {
                    style: 'currency',
                    currency: 'EUR'
                }) + '/m²' : '';
            }
        },
        grid: {
            left: '1%',
            right: '3%',
            top: '0',
            bottom: '15',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            max: 1,
        },
        yAxis: {
            type: 'category',
            data: [],
            axisLabel: {
                fontSize: 12
            }
        },

        color: ['#004854', '#BA7D3E'],
        series: []
    };
    rentData = {
        series: [],
    };

    // Graphique Evolution du capital net
    capitalEchartsIntance = null;
    options_Evol_Capital = {
        tooltip: {
            trigger: 'item',
            formatter: params => {
                let lib = 'Année ' + params.name + ' <br/>' + '<span style="font-size:24px; color: ' + params.color + '">• </span>' + params.seriesName + ' : ' + params.value + '€';
                return lib;
            },
        },
        legend: {},
        xAxis: [
            {
                type: 'category',
                name: 'Année',
                nameLocation: 'center',
                nameTextStyle: {
                    align: 'center',
                    lineHeight: 50,
                    fontWeight: 'bold',
                    fontSize: 16
                },
                axisLabel: {
                    fontSize: 16,
                },
                data: []
            }
        ],

        yAxis: [
            {
                type: 'value',
                axisLabel: {
                    formatter: '{value} €',
                    fontSize: 16,
                }
            },
        ],
        series: []
    };
    capitalData = {
        series: [],
    };

    // Graphique évolution du cash flow
    cashflowEchartsIntance = null;

    // Graphique évolution de la population
    popEchartsIntance = null;
    popOptions = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: '{a} <br/>{b} : {c}'
        },
        grid: [{
            left: '10px',
            right: '10px',
            top: '10px',
            bottom: '20px',
            containLabel: true
        }],
        xAxis: {
            type: 'category',
            data: [],
            axisTick: {
                alignWithLabel: true,
            },
        },

        yAxis: {
            type: 'value',
            min: 1000000,
        },
        color: ['#5FB761'],

        series: []

    };

    popData = {};

    // Entreprise
    shopOptions = {
        tooltip: {
            trigger: 'item',
            formatter: '{c} {b} ({d}%)'
        },
        legend: {
            orient: 'vertical',
            left: '0px',
            top: '0px',
            align: 'left',
            selectedMode: false,
            data: ['Grande distribution', 'Santé', 'Shopping', 'Commerces de proximité', 'Magasins pour la maison', 'Autres']
        },
        calculable: true,
    };

    shopData = {
        series: []
    };

    // Ecoles
    schoolOptions = {
        tooltip: {
            trigger: 'item',
            formatter: '{c} {b} ({d}%)'
        },
        legend: {
            orient: 'vertical',
            left: '0px',
            top: '0px',
            align: 'left',
            selectedMode: false,
            data: ['Enfance', 'Lycée', 'Enseignement supérieur', 'Formations']
        },
        calculable: true,
    };

    schoolData = {
        series: []
    };
    // Contact
    pro_data = {
        mobile: '',
    };
    title = '';

    constructor(
        public cityService: CityService,
        private http: HttpClient,
        private route: ActivatedRoute,
        private adService: AdService,
        private userService: UserService,
        public authenticationService: AuthenticationService,
        public dialog: MatDialog,
        private alertService: AlertService,
        public trackingService: TrackingService,
        private router: Router) {
    }

    ngOnInit(): void {
        this.pdfConfig = {
            societe: '',
            template: ['classique'],
            logo_w: 557,
            logo_h: 211,
            logo_url: 'assets/pdf/izimmo/logo-light.png',
            logo_small_w: 557,
            logo_small_h: 211,
            logo_small_url: 'assets/pdf/izimmo/logo.png',
            logo_small_style: '',
            display_legal_notice: false,
            display_note: false,
            display_contact: true,
            contact_bkg: '#144551',
            h2_class: 'underline',
            h2_underline_url: '',
            h3_class: '',
            font_family: 'Rubik',
            text_color: '#083E4B',
            second_color: '#0E333C',
            visuel_1: 'assets/pdf/izimmo/img1.png',
            visuel_1b: 'assets/pdf/izimmo/img2.jpg',
            visuel_2: 'assets/pdf/izimmo/img2.jpg',
            visuel_3: 'assets/pdf/izimmo/img2.jpg',
            color_kpi_1: '#79C447',
            color_kpi_2: '#FF5455',
            color_kpi_3: '#2691D0',
            color_kpi_4: '#FABB3D',
            color_kpi_5: '#1277AA',
            contact_tpl: 'agence',
            contact_visuel: '',
            contact: `<b>Izimmo Impact</b><br/>
                            3, rue Meyerbeer<br/>
                            75009 Paris<br/>
                            <br/>
                            Tél : 01 85 09 50 73`,
            marque_blanche: false,
        };

        let css = `
                #book * {
                    font-family: '` + this.pdfConfig.font_family + `-Regular';
                    color: ` + this.pdfConfig.text_color + `;
                }
                #book textarea {
                    color: #343a40;
                }
                #book .bilan_comptable td  {
                    font-family: 'arial';
                }
                #book .contact * {
                    color: white;
                }
                #book .text-color {
                    color: ` + this.pdfConfig.text_color + ` !important;
                }
                #book .title input {
                    font-family: '` + this.pdfConfig.font_family + `-Medium';
                    color: ` + this.pdfConfig.text_color + `;
                }
                #book h2 {
                    font-family: '` + this.pdfConfig.font_family + `-Medium';
                }
                #book .card .card-header .card-title h3 {
                    font-family: '` + this.pdfConfig.font_family + `-Regular';
                }
                #book .block.card label {
                    font-family: "` + this.pdfConfig.font_family + `-Regular";
                }
                #book .block_recap table td {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .block_recap table th, #book .block_recap table th > div, #book .block_recap table th > div > span {
                    font-family: "` + this.pdfConfig.font_family + `-Regular";
                }
                #book .desc, #book .desc textarea {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .notes, #book .notes textarea {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .contact {
                    background-color: ` + this.pdfConfig.contact_bkg + `;
                }
                #book .contact .col-md-6 {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .contact .col-md-6 b {
                    font-family: "` + this.pdfConfig.font_family + `-SemiBold";
                    color: #BD8143;
                    display: block;
                }
                #book h2.underline::after {
                    border-color: ` + this.pdfConfig.second_color + ` !important;
                }
                .kpi-color-1 {
                    background-color: ` + this.pdfConfig.color_kpi_1 + `;
                }
                .kpi-color-2 {
                    background-color: ` + this.pdfConfig.color_kpi_2 + `;
                }
                .kpi-color-3 {
                    background-color: ` + this.pdfConfig.color_kpi_3 + `;
                }
                .kpi-color-4 {
                    background-color: ` + this.pdfConfig.color_kpi_4 + `;
                }
                .kpi-color-5 {
                    background-color: ` + this.pdfConfig.color_kpi_5 + `;
                }
            `;

        const head = document.getElementsByTagName('head')[0];
        const style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(css));
        head.appendChild(style);

        this.user = this.authenticationService.currentUser;

        if (this.user.pro_data === '') {
            this.alertService.error('Veuillez renseigner les informations de votre agence dans la partie "Mon compte"');
        } else {
            this.pro_data = JSON.parse(this.user.pro_data);
        }

        const available_page = ['annonce', 'secteur', 'finance', 'patrimoniale'];
        if (this.user.user_dashboard.pdf_profil == '') {
            this.user.user_dashboard.pdf_profil = 'classique';
            this.user.user_dashboard.pdf_quality = 'normal';
            this.user.user_dashboard.pdf_page = available_page;
        } else {
            let page = [];
            this.user.user_dashboard.pdf_page.forEach(keys => {
                if (available_page.includes(keys)) {
                    page.push(keys);
                }
            });
            this.user.user_dashboard.pdf_page = page;
        }

        this.route.parent.params.subscribe(params => {
            this.params = params;

            // Source de vérité unique : on réutilise le favori déjà chargé et mis en
            // cache par le composant parent (detail-wrap), au lieu de refaire un GET.
            // Un GET séparé créait un 2e objet favori : les modifications saisies ici
            // étaient ensuite écrasées par le PUT complet des onglets du dossier (et
            // les modifications du dossier n'étaient pas vues ici tant que le PUT
            // debouncé n'était pas parti).
            const fetch$ = this.adService.getCacheFavorite();
            fetch$.subscribe(result => {
                this.favorite = this.adService.updateValues(result);

                this.setRentData(this.favorite.furnish);
                this.setPriceData(this.favorite.estate_type);
                this.setPriceEvolData();
                this.setChargeData();
                this.setPopData();
                this.setShopData();
                this.setSchoolData();
                this.callImpot();

                if (this.favorite.ad.real_estate_type == 'immeuble' || this.favorite.nb_lots > 1 || this.favorite.lots.length > 1) {
                    let lot = this.favorite.lots.length;
                    if (this.favorite.nb_lots >= this.favorite.lots.length) {
                        lot = this.favorite.nb_lots;
                    }
                    this.title = 'Immeuble de ' + lot + '  lots | ' + this.favorite.ad_city.name;
                } else {
                    this.title = this.favorite.estate_type + ' | ' + this.favorite.ad_city.name;
                }

                this.favorite.description = this.favorite.description.replace(/<[^>]*>/g, '');
                this.advice_price = this.favorite.advice_price;
            }, error => {
                if (error != 'token_outdate') {
                    this.alertService.error('Favoris introuvable', true);
                    this.router.navigate(['/app/favorites', params.id]);
                }
            });

        });
    }

    createPdf() {
        if (!this.authenticationService.isAllowed('expert')) {

            this.trackingService.click('pdf_upgrade_open', '');
            const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                width: '520px',
                data: {visuel: 'assets/export_1.png', plan: 'Expert', feature: 'Dossier bancaire'}
            });
            this.authenticationService.currentUser.user_onboarding.popup_search_fav = true;
            this.userService.updateOnboarding(this.authenticationService.currentUser);

            dialogRef.afterClosed().subscribe(result => {
                if (result === true) {
                    this.trackingService.click('pdf_upgrade_valid', '');
                } else {
                    this.trackingService.click('pdf_upgrade_cancel', '');
                }
            });
            return;
        }
        this.loading = true;

        function filter(node) {
            return (node.className !== 'logo' && node.className !== 'fontChange');
        }

        var scale = 1;
        if (this.user.user_dashboard.pdf_quality == 'hd') {
            scale = 2;
        }
        var offsetWidth = 1339.38;
        var offsetHeight = 1894.2525;

        if (this.user.user_dashboard.pdf_page.includes('annonce')) {
            htmlToImage.toPng(document.getElementById('annonce') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgAnnonce = dataUrl;
                    this.imgDone.push('annonce');
                    // window.open(dataUrl, '_blank');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('secteur')) {
            htmlToImage.toPng(document.getElementById('secteur') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgSecteur = dataUrl;
                    this.imgDone.push('secteur');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('secteur_bis')) {
            htmlToImage.toPng(document.getElementById('secteur_bis') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgSecteurBis = dataUrl;
                    this.imgDone.push('secteur_bis');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('finance')) {
            htmlToImage.toPng(document.getElementById('finance') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgFinance = dataUrl;
                    this.imgDone.push('finance');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('patrimoniale')) {
            htmlToImage.toPng(document.getElementById('patrimoniale') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgPatrimoniale = dataUrl;
                    this.imgDone.push('patrimoniale');
                    this.downloadPdf();
                });
        }
    }

    downloadPdf() {
        if (this.imgDone.length == this.user.user_dashboard.pdf_page.length) {

            const pdf = new jsPDF('p', 'px', 'a4');

            const width = pdf.internal.pageSize.getWidth();
            const height = pdf.internal.pageSize.getHeight();

            pdf.addFont('assets/pdf/font/' + this.pdfConfig.font_family + '-SemiBold.ttf', '' + this.pdfConfig.font_family + '-SemiBold', 'normal');
            pdf.setFont('Gilroy-SemiBold');

            if (this.user.user_dashboard.pdf_page.includes('annonce')) {
                pdf.addPage();
                pdf.addImage(this.imgAnnonce, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                let height_logo = Math.round(this.pdfConfig.logo_h / 3);
                if (height_logo > 80) {
                    height_logo = 80;
                }
                const with_logo = this.pdfConfig.logo_w / (this.pdfConfig.logo_h / height_logo);
                pdf.addImage(this.pdfConfig.logo_url, 'PNG', (width - with_logo) / 2, 25, with_logo, height_logo);
            }

            // Title (dont take user modification)
            pdf.addFont('assets/pdf/font/' + this.pdfConfig.font_family + '-SemiBold.ttf', '' + this.pdfConfig.font_family + '-SemiBold', 'normal');
            pdf.setFont('' + this.pdfConfig.font_family + '-SemiBold');
            pdf.setTextColor(this.pdfConfig.text_color);
            pdf.setFontSize(8);
            // pdf.setFontSize(22);
            // pdf.text(this.favorite.estate_type + ' | ' + this.favorite.rooms + ' pièces | ' + this.favorite.square + 'm2', 220, 150, {align: 'center'});

            const height_small_logo = 20;
            const with_small_logo = this.pdfConfig.logo_small_w / (this.pdfConfig.logo_small_h / height_small_logo);
            let x = 20;
            if (this.pdfConfig.logo_small_style.includes('center')) {
                x = (width - with_small_logo) / 2;
            }

            if (this.user.user_dashboard.pdf_page.includes('secteur')) {
                pdf.addPage();
                pdf.addImage(this.imgSecteur, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', x, 20, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('secteur_bis')) {
                pdf.addPage();
                pdf.addImage(this.imgSecteurBis, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', x, 20, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('finance')) {
                pdf.addPage();
                pdf.addImage(this.imgFinance, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', x, 20, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('patrimoniale')) {
                pdf.addPage();
                pdf.addImage(this.imgPatrimoniale, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', x, 20, with_small_logo, height_small_logo);
            }

            pdf.deletePage(1);
            pdf.save(this.favorite.title + '.pdf');

            // Save export date
            this.http.put(`${environment.apiUrl}app/favorite/${this.favorite.id}/export`, {}).subscribe(result => {
                this.alertService.success('Export terminé');
            }, error => {
                console.log(error);
            });
            this.imgAnnonce = '';
            this.imgSecteur = '';
            this.imgFinance = '';
            this.imgPatrimoniale = '';
            this.imgDone = [];
            this.loading = false;
        }
    }

    setRentData(furnish) {
        this.rentOptions.yAxis.data = ['1 pièces / Studio', '2 pièces', '3 pièces', '4 pièces', '5 pièces', 'Appartement', 'Maison', 'Garage / Parking'];

        this.rentOptions.xAxis.max = Math.round([
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[1].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[2].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[3].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[4].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[5].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville.A.lM,
            this.favorite.ad_city.loyer_moyen_ville.M.lM,
            this.favorite.ad_city.loyer_moyen_ville.P.lM,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[1].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[2].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[3].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[4].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[5].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_meuble.A.lM,
            this.favorite.ad_city.loyer_moyen_ville_meuble.M.lM,
            this.favorite.ad_city.loyer_moyen_ville.P.lM,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[1].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[2].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[3].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[4].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[5].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_non_meuble.A.lM,
            this.favorite.ad_city.loyer_moyen_ville_non_meuble.M.lM,
            this.favorite.ad_city.loyer_moyen_ville.P.lM,
        ].sort((a, b) => b - a)[0] / 1);

        if (furnish === 0) {
            this.rentData = {
                series: [
                    {
                        name: this.favorite.ad_city.name,
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[1].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[2].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[3].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[4].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[5].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville.A.lM,
                            this.favorite.ad_city.loyer_moyen_ville.M.lM,
                            this.favorite.ad_city.loyer_moyen_ville.P.lM.toPrecision(3),
                            0,
                        ]
                    },
                ]
            };
        } else if (furnish === 1) {
            this.rentData = {
                series: [
                    {
                        name: this.favorite.ad_city.name,
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[1].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[2].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[3].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[4].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[5].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_meuble.A.lM,
                            this.favorite.ad_city.loyer_moyen_ville_meuble.M.lM,
                            this.favorite.ad_city.loyer_moyen_ville.P.lM.toPrecision(3),
                            0,
                        ]
                    },
                ]
            };
        } else if (furnish === 2) {
            this.rentData = {
                series: [
                    {
                        name: this.favorite.ad_city.name,
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[1].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[2].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[3].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[4].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[5].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_non_meuble.A.lM,
                            this.favorite.ad_city.loyer_moyen_ville_non_meuble.M.lM,
                            this.favorite.ad_city.loyer_moyen_ville.P.lM.toPrecision(3),
                            0,
                        ]
                    },
                ]
            };
        }

        if (this.favorite.id !== '') {
            this.rentOptions.yAxis.data.push('Votre projet');
            this.rentData.series.push(
                {
                    name: 'Votre projet',
                    type: 'bar',
                    stack: '1',
                    data: [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0, // One more for the city below
                        this.favorite.square > 0 ? (this.favorite.amount_rent / this.favorite.square).toPrecision(3) : 0,
                    ]
                });
        }

        if (this.favorite.ad_city.loyer_moyen_ville.A.lM > 0 || this.favorite.ad_city.loyer_moyen_ville.M.lM > 0) {
            this.rentOptions.yAxis.data = [this.favorite.ad_city.name].concat(this.rentOptions.yAxis.data);
            this.rentData.series[0].data = [this.favorite.ad_city.loyer_moyen_petite_ville.lM.toPrecision(3)].concat(this.rentData.series[0].data);
        } else {
            this.rentOptions.yAxis.data = [this.favorite.ad_city.zip_code].concat(this.rentOptions.yAxis.data);
            this.rentData.series[0].data = [this.favorite.ad_city.loyer_moyen_petite_ville_cp.lM].concat(this.rentData.series[0].data);
        }

        if (this.rentEchartsIntance) {
            this.rentEchartsIntance.setOption(this.rentOptions);
        }
    }

    setPriceData(estateType) {
        this.priceOptions.yAxis.data = ['1 pièces / Studio', '2 pièces', '3 pièces', '4 pièces', '5 pièces', 'Appartement', 'Maison'];

        this.priceOptions.xAxis.max = Math.round([
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[1] ? this.favorite.ad_city.prix_commune_nb_piece.A[1].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[2] ? this.favorite.ad_city.prix_commune_nb_piece.A[2].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[3] ? this.favorite.ad_city.prix_commune_nb_piece.A[3].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[4] ? this.favorite.ad_city.prix_commune_nb_piece.A[4].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[5] ? this.favorite.ad_city.prix_commune_nb_piece.A[5].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[1] ? this.favorite.ad_city.prix_commune_nb_piece.M[1].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[2] ? this.favorite.ad_city.prix_commune_nb_piece.M[2].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[3] ? this.favorite.ad_city.prix_commune_nb_piece.M[3].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[4] ? this.favorite.ad_city.prix_commune_nb_piece.M[4].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[5] ? this.favorite.ad_city.prix_commune_nb_piece.M[5].pM : 0,
            this.favorite.total_price / this.favorite.square
        ].sort((a, b) => b - a)[0] / 1);

        if (estateType === 'Maison') {
            this.priceData = {
                series: [
                    {
                        name: 'Maison',
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[1] ? this.favorite.ad_city.prix_commune_nb_piece.M[1].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[2] ? this.favorite.ad_city.prix_commune_nb_piece.M[2].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[3] ? this.favorite.ad_city.prix_commune_nb_piece.M[3].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[4] ? this.favorite.ad_city.prix_commune_nb_piece.M[4].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[5] ? this.favorite.ad_city.prix_commune_nb_piece.M[5].pM : null,
                            this.favorite.ad_city.prix_commune.A.pM,
                            this.favorite.ad_city.prix_commune.M.pM,
                        ]
                    }
                ]
            };

            this.priceOptions.yAxis.data = [this.favorite.ad_city.zip_code].concat(this.priceOptions.yAxis.data);
            this.priceData.series[0].data = [this.favorite.ad_city.prix_commune.B.pM.toPrecision(3)].concat(this.priceData.series[0].data);
        } else {
            this.priceData = {
                series: [
                    {
                        name: 'Appartement',
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[1] ? this.favorite.ad_city.prix_commune_nb_piece.A[1].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[2] ? this.favorite.ad_city.prix_commune_nb_piece.A[2].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[3] ? this.favorite.ad_city.prix_commune_nb_piece.A[3].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[4] ? this.favorite.ad_city.prix_commune_nb_piece.A[4].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[5] ? this.favorite.ad_city.prix_commune_nb_piece.A[5].pM : null,
                            this.favorite.ad_city.prix_commune.A.pM,
                            this.favorite.ad_city.prix_commune.M.pM,
                        ]
                    },
                ]
            };

            this.priceOptions.yAxis.data = [this.favorite.ad_city.name].concat(this.priceOptions.yAxis.data);
            this.priceData.series[0].data = [this.favorite.ad_city.prix_commune.B.pM.toPrecision(3)].concat(this.priceData.series[0].data);
        }

        this.priceOptions.yAxis.data.push('Votre projet');
        this.priceData.series.push(
            {
                name: 'Votre projet',
                type: 'bar',
                stack: '1',
                data: [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0, // One more for the city
                    (this.favorite.total_price / this.favorite.square).toPrecision(4),
                ]
            });

        if (this.priceEchartsIntance) {
            this.priceEchartsIntance.setOption(this.priceOptions);
        }
    }

    setPriceEvolData() {

        if (this.favorite.ad_city.city_code === '') {
            return;
        }
        const dataAdep = [];
        const dataMdep = [];
        const dataAville = [];
        const dataMville = [];

        this.priceEvolOptions.xAxis.data = PRICE_EVOL_LEGENT;
        this.priceEvolOptions.xAxis.data.forEach(keys => {

            if (this.favorite.ad_city.prix_departement.A != null && this.favorite.ad_city.prix_departement.A[keys] !== undefined) {
                dataAdep.push(this.favorite.ad_city.prix_departement.A[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_departement.A[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_departement.A[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataAdep.push('');
            }

            if (this.favorite.ad_city.prix_departement.M != null && this.favorite.ad_city.prix_departement.M[keys] !== undefined) {
                dataMdep.push(this.favorite.ad_city.prix_departement.M[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_departement.M[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_departement.M[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataMdep.push('');
            }

            if (this.favorite.ad_city.prix_ville.A != null && this.favorite.ad_city.prix_ville.A[keys] !== undefined) {
                dataAville.push(this.favorite.ad_city.prix_ville.A[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_ville.A[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_ville.A[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataAville.push('');
            }

            if (this.favorite.ad_city.prix_ville.M != null && this.favorite.ad_city.prix_ville.M[keys] !== undefined) {
                dataMville.push(this.favorite.ad_city.prix_ville.M[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_ville.M[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_ville.M[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataMville.push('');
            }
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.departement + ' : Appartement',
            type: 'line',
            data: dataAdep
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.departement + ' : Maison',
            type: 'line',
            data: dataMdep
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.name + ' : Appartement',
            type: 'line',
            data: dataAville
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.name + ' : Maison',
            type: 'line',
            data: dataMville
        });

        this.priceEvolOptions.legend.selected = {
            [this.favorite.ad_city.departement + ' : Appartement']: dataAville.filter(Boolean).length < 1,
            [this.favorite.ad_city.departement + ' : Maison']: dataMville.filter(Boolean).length < 1,
            [this.favorite.ad_city.name + ' : Appartement']: dataAville.filter(Boolean).length >= 1,
            [this.favorite.ad_city.name + ' : Maison']: dataMville.filter(Boolean).length >= 1,
        };
    }

    setChargeData() {
        let data = {
            series: [
                {
                    right: '20%',
                    name: '',
                    type: 'pie',
                    radius: ['60%', '90%'],
                    avoidLabelOverlap: false,
                    fontSize: 30,
                    itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    data: []
                }
            ]
        };

        if (this.favorite.monthly > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.monthly), name: 'Mensualité'});
        }
        if (this.favorite.amount_property_tax > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.amount_property_tax / 12), name: 'Taxe foncière'});
        }
        if (this.favorite.agence_rental / 12 + (this.favorite.agence * this.favorite.amount_rent) > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.agence_rental / 12 + (this.favorite.agence * this.favorite.amount_rent) / 100), name: 'Gestion en agence'});
        }
        if (this.favorite.amount_copro > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.amount_copro / 12), name: 'Charges de copro'});
        }
        if (this.favorite.amount_rent_insurance > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.amount_rent_insurance * this.favorite.amount_rent / 100), name: 'GLI'});
        }
        if (this.favorite.building_insurance > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.building_insurance / 12), name: 'Assurance PNO'});
        }
        if (this.favorite.cash_flow > 0) {
            data.series[0].data.push({value: Math.round((this.favorite.cash_flow > 0) ? this.favorite.cash_flow : 0), name: 'Cash flow'});
        }

        this.chargeData = data;

        if (this.favorite.other_bill > 0) {
            this.chargeData.series[0].data.push({value: Math.round(this.favorite.other_bill / 12), name: 'Autres frais'});
        }
        if (this.favorite.accouting_fees + this.favorite.cfe_contribution > 0) {
            this.chargeData.series[0].data.push({value: Math.round((this.favorite.accouting_fees + this.favorite.cfe_contribution) / 12), name: 'Frais de comptabilité'});
        }
    }

    setPopData() {

        this.popOptions.yAxis.min = 1000000;
        this.popOptions.xAxis.data = [];

        const dataPop = [];
        Object.keys(this.favorite.ad_city.demographie_annuelle).forEach(keys => {
            if (keys !== 'Cr') {
                dataPop.push(this.favorite.ad_city.demographie_annuelle[keys]);
                this.popOptions.xAxis.data.push(keys);
                if (this.popOptions.yAxis.min > (this.favorite.ad_city.demographie_annuelle[keys] * 0.9)) {
                    this.popOptions.yAxis.min = Math.round(this.favorite.ad_city.demographie_annuelle[keys] * 0.9 / 1000 - 1) * 1000;
                }
            }
        });
        this.popData = {
            series: [
                {
                    name: this.favorite.ad_city.name,
                    type: 'bar',
                    data: dataPop,
                },
            ]
        };

        if (this.popEchartsIntance) {
            this.popEchartsIntance.setOption(this.popOptions);
        }
    }

    setShopData() {
        this.shopData = {
            series: [
                {
                    name: '',
                    type: 'pie',
                    center: ['280', '50%'],
                    radius: ['55%', '80%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'inner',
                    },
                    color: ['#67C2EF', '#79C447', '#FABB3D', '#BA7D3E', '#9C9C9C', '#FF5455'],

                    data: [
                        {value: Math.round(this.favorite.ad_city.commerce.hypmar + this.favorite.ad_city.commerce.supmar + this.favorite.ad_city.commerce.surge), name: 'Grande distribution'},
                        {value: Math.round(this.favorite.ad_city.commerce.opt + this.favorite.ad_city.commerce.medi + this.favorite.ad_city.commerce.pharma), name: 'Santé'},
                        {value: Math.round(this.favorite.ad_city.commerce.sport + this.favorite.ad_city.commerce.vet + this.favorite.ad_city.commerce.chaus), name: 'Shopping'},
                        {
                            value: Math.round(this.favorite.ad_city.commerce.boulan + this.favorite.ad_city.commerce.epice + this.favorite.ad_city.commerce.poisson +
                                this.favorite.ad_city.commerce.supe + this.favorite.ad_city.commerce.bouch), name: 'Commerces de proximité'
                        },
                        {
                            value: Math.round(this.favorite.ad_city.commerce.brico + this.favorite.ad_city.commerce.droguerie + this.favorite.ad_city.commerce.electro
                                + this.favorite.ad_city.commerce.equ + this.favorite.ad_city.commerce.revet + this.favorite.ad_city.commerce.meub), name: 'Magasins pour la maison'
                        },
                        {
                            value: Math.round(this.favorite.ad_city.commerce.essence + this.favorite.ad_city.commerce.fleur + this.favorite.ad_city.commerce.horlog
                                + this.favorite.ad_city.commerce.lib + this.favorite.ad_city.commerce.parfum), name: 'Autres'
                        },
                    ],
                },
            ]
        };
    }

    setSchoolData() {
        this.schoolData = {
            series: [
                {
                    name: '',
                    type: 'pie',
                    center: ['280', '50%'],
                    radius: ['55%', '80%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'inner',
                    },
                    color: ['#67C2EF', '#79C447', '#FABB3D', '#FF5455'],

                    data: [
                        {
                            value: Math.round(this.favorite.ad_city.ecole.maternelle + this.favorite.ad_city.ecole.elementaire + this.favorite.ad_city.ecole.college),
                            name: 'Enfance'
                        },
                        {
                            value: Math.round(this.favorite.ad_city.ecole.lycee_gen_techno + this.favorite.ad_city.ecole.lycee_pro + this.favorite.ad_city.ecole.lycee_techniqe_etou_pro_agricole),
                            name: 'Lycée'
                        },
                        {
                            value: Math.round(this.favorite.ad_city.ecole.cpge + this.favorite.ad_city.ecole.ecole_inge + this.favorite.ad_city.ecole.institut_universitaire
                                + this.favorite.ad_city.ecole.enseign_general_sup_prive + this.favorite.ad_city.ecole.enseign_sup_agricole + this.favorite.ad_city.ecole.unite_de_form_et_recherche
                                + this.favorite.ad_city.ecole.autre_enseign_sup + this.favorite.ad_city.ecole.autre_postbac),
                            name: 'Enseignement supérieur'
                        },
                        {
                            value: Math.round(this.favorite.ad_city.ecole.centre_form_agricole + this.favorite.ad_city.ecole.centre_form_apprentis + this.favorite.ad_city.ecole.form_apprentissage_agricole
                                + this.favorite.ad_city.ecole.form_commerce + this.favorite.ad_city.ecole.form_sante + this.favorite.ad_city.ecole.form_sport
                                + this.favorite.ad_city.ecole.greta + this.favorite.ad_city.ecole.autre_form_continu), name: 'Formations'
                        }
                    ],
                },
            ]
        };
    }

    callImpot() {

        this.favorite = this.adService.cleanInput(this.favorite);
        this.favorite = this.adService.updateValues(this.favorite);

        const fav = this.adService.cleanForImpot(this.favorite, this.user);

        if (fav.fiscal_choice !== '' && fav.price > 0) {
            fav.is_credit_differed = false;
            this.http.post<any>(environment.impotUrl, fav)
                .subscribe(data => {
                    if (data.comparatif[fav.fiscal_choice] != undefined && data.comparatif[fav.fiscal_choice].enrichment !== undefined) {
                        this.enrichment = data.comparatif[fav.fiscal_choice].enrichment;
                    }
                    if (data[fav.fiscal_choice].cols !== undefined) {

                        // Graphique compraison des régimes fiscaux
                        if (this.favorite.selling == true) {
                            this.result = data[fav.fiscal_choice].impots.slice(0, this.favorite.selling_year);
                        } else {
                            this.result = data[fav.fiscal_choice].impots;
                        }

                        // 5 dernier + X premier
                        // if (this.result.length > 19) {
                        //     this.result = this.result.slice(0, 19 - 5).concat(this.result.slice(this.result.length - 5, this.result.length));
                        // }

                        if (this.result[this.result.length - 1].loyers_percus > 99999 || this.favorite.total_price > 999999) {
                            this.hideUnit = true;
                        }
                        this.displayedColumns = data[fav.fiscal_choice].cols;

                        // Graphique Evolution du capital net
                        this.data_CF_cum = [];
                        const data_Amortissement = [];
                        const data_Enrich = [];

                        var cumul = 0;
                        Object.keys(this.result).forEach(keys => {
                            if (parseInt(keys, 10) < this.favorite.duration) {
                                cumul = cumul + Math.round(this.result[keys].cash_flow);
                                this.data_CF_cum.push(cumul);

                                data_Amortissement.push(Math.round(this.favorite.total_price - this.favorite.apport - this.result[keys].capital_restant_du));
                                data_Enrich.push(Math.round(this.favorite.total_price - this.favorite.apport - this.result[keys].capital_restant_du) + cumul);
                                if (parseInt(keys, 10) == 9) { // 10eme année
                                    this.enrichment_10 = Math.round(this.favorite.total_price - this.favorite.apport - this.result[keys].capital_restant_du) + cumul;
                                }

                                this.amort_moy = Math.round((this.favorite.total_price - this.result[keys].capital_restant_du) / this.favorite.duration);
                            }
                        });

                        var d = this.favorite.duration;
                        if (this.favorite.selling == true) {
                            d = this.favorite.selling_year;
                        }
                        this.options_Evol_Capital.xAxis = [
                            {
                                type: 'category',
                                name: 'Année',
                                nameLocation: 'center',
                                nameTextStyle: {
                                    align: 'center',
                                    lineHeight: 50,
                                    fontWeight: 'bold',
                                    fontSize: 18
                                },
                                axisLabel: {
                                    fontSize: 16,
                                },
                                data: Array.from({length: d}, (_, i) => i + 1)
                            }
                        ];

                        this.options_Evol_Capital.series = [
                            {
                                type: 'line',
                                lineStyle: {
                                    width: 3
                                },
                                symbolSize: 12,
                                name: 'Trésorerie cumulée',
                                color: '#67C2EF',
                                data: this.data_CF_cum
                            },
                            {
                                type: 'line',
                                lineStyle: {
                                    width: 3
                                },
                                symbolSize: 12,
                                name: 'Capital remboursé',
                                color: '#FABB3D',
                                data: data_Amortissement
                            },
                            {
                                type: 'line',
                                lineStyle: {
                                    width: 3
                                },
                                symbolSize: 12,
                                name: 'Enrichissement total',
                                color: '#78C447',
                                data: data_Enrich
                            },

                        ];
                        this.capitalData.series = this.options_Evol_Capital.series;
                    }

                    setTimeout(function() {
                        this.ready = true;
                    }.bind(this), 5000);


                }, err => {
                    console.log(err);
                });
        } else {
            const champsManquants = [];
            if (fav.fiscal_choice === '') {
                champsManquants.push('le régime fiscal');
            }
            if (!(fav.price > 0)) {
                champsManquants.push('le prix');
            }
            this.alertService.error('Informations manquantes pour la fiscalité : ' + champsManquants.join(' et ') + '.');
        }
    }

    onRentChartInit(ec) {
        this.rentEchartsIntance = ec;
    }

    onPriceChartInit(ec) {
        this.priceEchartsIntance = ec;
    }

    onChargeChartInit(ec) {
        this.chargeEchartsIntance = ec;
    }

    onChartECInit(ec) {
        this.capitalEchartsIntance = ec;
    }

    onChartCFInit(ec) {
        this.cashflowEchartsIntance = ec;
    }

    onChartPopInit(ec) {
        this.popEchartsIntance = ec;
    }

    edit(event, fields = '') {
        if (fields == 'description') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.description, fields);
        } else if (fields == 'comment') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.comment, fields);
        } else {
            this.adService.updateFavorite(this.favorite);
        }
    }

    onPageChange(val) {
        if (_.difference(val, this.user.user_dashboard.pdf_page).length !== 0) {
            // Checked
            this.user.user_dashboard.pdf_page = _.without(this.user.user_dashboard.pdf_page, 'action');
            this.user.user_dashboard.pdf_page.push(_.difference(val, this.user.user_dashboard.pdf_page)[0]);
        } else if (_.difference(this.user.user_dashboard.pdf_page, val).length !== 0) {
            // Unchecked
            this.user.user_dashboard.pdf_page = _.without(this.user.user_dashboard.pdf_page, _.difference(this.user.user_dashboard.pdf_page, val)[0]);
        }
        this.updateDashboard();
    }

    updateDashboard() {
        this.userService.updateDashboard(this.user);
    }

    openPageSelection() {
        $('#pageSelection .isMinimizable').toggleClass('minimize');
    }

    openDropdown() {
        $('#optionDropdown').addClass('optionDropdownOnboarding');
    }

    toFloat(s) {
        return parseFloat(s);
    }

    upFont() {
        this.fontSize++;
        document.getElementById('descFields').style.fontSize = this.fontSize + 'px';
        if (this.fontSize > 24) {
            document.getElementById('descFields').style.lineHeight = 'normal';
        }
    }

    downFont() {
        this.fontSize--;
        document.getElementById('descFields').style.fontSize = this.fontSize + 'px';
        if (this.fontSize >= 24) {
            document.getElementById('descFields').style.lineHeight = '26px';
        }
    }

    protected readonly EVOL_DEMO_LAST_YEAR = EVOL_DEMO_LAST_YEAR;
}
